module.exports = __webpack_public_path__ + "static/media/lew_logo.5150e7d1.svg";